import React from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete as AutocompleteMui } from '@material-ui/lab';
import { IAutocomplete, IOptions } from './interfaces';
import { Controller } from 'react-hook-form';
export type { IOptions } from './interfaces';

export const Autocomplete = (props: IAutocomplete) => {
  const {
    objects: objectsProps,
    objectKey,
    objectValue,
    label,
    loading,
    defaultValue,
    showObjectKey,
    variant,
    control,
    name
  } = props;

  const options: IOptions[] = [];
  const objects = objectsProps || [];

  objects.forEach((object) => {
    if (objectKey && objectValue) {
      options.push({ key: object[objectKey], value: object[objectValue] });
    }
  });

  const index = objects.findIndex((object) => {
    return object[objectKey] === defaultValue;
  });

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={options[index]}
      render={({ field: { onChange }, fieldState: { error } }) => (
        <AutocompleteMui
          loading={loading}
          options={options}
          key={options[0]?.key}
          getOptionLabel={(option: IOptions): string =>
            showObjectKey ? `${option.key} - ${option.value}` : option.value
          }
          getOptionSelected={(option, value) => option.value === value.value}
          loadingText="Carregando..."
          noOptionsText="Sem opções"
          onChange={(_, obj) => onChange(obj)}
          renderInput={(params) => (
            <TextField
              {...params}
              variant={variant || 'standard'}
              label={label}
              fullWidth
              error={!!error}
              helperText={error?.message || null}
            />
          )}
        />
      )}
    />
  );
};
